// client/src/services/tutorialService.js
//
// Etat du tutoriel d'onboarding :
//  - flag LOCAL (localStorage) : couvre les comptes invites et le passage
//    invite -> compte reel sur le meme appareil (le tutoriel ne se relance
//    pas a la creation du compte).
//  - flag SERVEUR (users.reels) : suit le compte sur tous ses appareils.
// Complet = flag local OU flag serveur.

const LS_KEY = 'elementum_tutorial_completed_v1';
const LS_SKIPPED_SESSION = 'elementum_tutorial_dismissed_session';

export const isLocallyCompleted = () => {
  try {
    return localStorage.getItem(LS_KEY) === '1';
  } catch (e) {
    return false;
  }
};

export const isDismissedThisSession = () => {
  try {
    return sessionStorage.getItem(LS_SKIPPED_SESSION) === '1';
  } catch (e) {
    return false;
  }
};

export const dismissForSession = () => {
  try {
    sessionStorage.setItem(LS_SKIPPED_SESSION, '1');
  } catch (e) { /* noop */ }
};

export const markCompleted = async () => {
  try {
    localStorage.setItem(LS_KEY, '1');
  } catch (e) { /* noop */ }
  // Persiste cote serveur pour les users reels (les invites ne sont pas
  // stockes : reponse ignoree sans erreur).
  try {
    const tokenRaw = localStorage.getItem('elemental_duelists_auth_token');
    const token = tokenRaw ? JSON.parse(tokenRaw) : null;
    if (token) {
      const api = (await import('../api/api')).default;
      await api.post('/auth/tutorial-state', { completed: true });
    }
  } catch (e) {
    // Silencieux : le flag local suffit
  }
};

export const resetTutorial = () => {
  try {
    localStorage.removeItem(LS_KEY);
    sessionStorage.removeItem(LS_SKIPPED_SESSION);
  } catch (e) { /* noop */ }
};

// Le tutoriel doit-il se lancer pour cet utilisateur ?
// user = objet user du AuthContext (peut etre un invite)
export const shouldLaunchTutorial = (user) => {
  if (isLocallyCompleted()) return false;
  if (isDismissedThisSession()) return false;
  if (user && user.tutorialCompleted === true) {
    // Flag serveur : complete partout, on aligne le flag local
    try { localStorage.setItem(LS_KEY, '1'); } catch (e) { /* noop */ }
    return false;
  }
  return true;
};
